import React from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/common/content.module.scss';
import Hidden from '@mui/material/Hidden';
import Image from '../common/Image';

const WhatWeDo = () => {
    return (
        <Section className={`${styles.nopad}`} hasPadding={true} id="what-we-do">
            <div className="container">
                <div className={`${styles.isme} row`} style={{alignItems:'center'}}>
                    <div id="imagec" className={`${styles.image2} col-12 col-lg-6`} >
                        <Hidden mdUp>
                        <h2 className={`${styles.header}`}> What We Do</h2>
                        </Hidden>
                        <Image className={`img-fluid`} src="/static/images/aboutus/what-we-do.png" alt="What we do" width="560" height="433" />
                    </div>
                    <div id="textc" className={`${styles.textcontent2} col-12 col-lg-6`} >
                        <Hidden mdDown>
                        <h2 className={`${styles.header}`}> What We Do<em className="title-el-cap"></em></h2>
                        </Hidden >
                        <h6 className={`${styles.subtitle}`}>Deliver ‘WoW’ Experiences to Customers:</h6>

                        <p className={`${styles.para}`}>We provide hassle-free services for the repair and maintenance of devices and appliances, thus improving the post-purchase ownership experience. Our customer obsession allows us to have the highest Net Promoter Score (NPS) globally in after-sales services.</p>

                    </div>

                </div>
            </div>
        </Section>
    );
}
export default WhatWeDo;